import React from "react";
import { TextInput } from "@astryxdesign/core";
import type { TextInputProps } from "@astryxdesign/core";
import styles from "./AuthTextInput.module.css";

export type AuthTextInputProps = Omit<TextInputProps, "className" | "xstyle">;

/**
 * Astryx's `TextInput` with the signed-out screens' focus colour. Takes the
 * same props; MUST be rendered inside an `AuthLayout`.
 */
const AuthTextInput = (props: AuthTextInputProps): React.ReactElement => {
  return <TextInput {...props} className={styles.field} />;
};

export default AuthTextInput;
